export function fetch(id) { return { type: 'TOURNAMENTS/FETCH', id } }
export function fetchUpcoming() { return { type: 'TOURNAMENTS/FETCH/UPCOMING' } }
export function fetchUpcomingAll() { return { type: 'TOURNAMENTS/FETCH/UPCOMING/ALL' } }
export function fetchPast() { return { type: 'TOURNAMENTS/FETCH/PAST' } }
export function clear() { return { type: 'TOURNAMENTS/CLEAR' } }
export function clearTournament() { return { type: 'TOURNAMENT/CLEAR' } }
export function fetchTournamentSeasons() { return { type: 'TOURNAMENT_SEASONS/FETCH' } }


// WEBPACK FOOTER //
// ./src/redux-sagas/actions/tournaments.js